import type { DealOffer } from "@/components/marketplace/deal-offers-types";

export function currentFormatOfferCount(input: {
  compareOfferCount?: number;
  offers: DealOffer[];
  formatCategory: DealOffer["formatCategory"];
}): number {
  if (input.compareOfferCount != null) return input.compareOfferCount + 1;
  return Math.max(
    1,
    input.offers.filter((candidate) => candidate.formatCategory === input.formatCategory).length,
  );
}
